import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BeneficialOwnershipWorkflow from 'components/BeneficialOwnership/BeneficialOwnershipWorkflow';
import { GlobalContext } from 'providers/GlobalProvider';

const BeneficialOwnershipPage: React.FC = () => {
  const { resetTicketDraft, wasTicketDraftRestored } =
    useContext(GlobalContext);
  const location = useLocation<{ resumeBeneficialOwnershipTicket?: unknown }>();

  useEffect(() => {
    // ticketDraft is a single app-wide slot on GlobalContext shared by every
    // Case-based tool. Without this, arriving here after saving in a
    // different tool inherits its leftover draft/_id instead of starting
    // fresh. Skip when explicitly resuming a saved ticket, or when a forced
    // re-login redirect just restored an in-progress draft (see
    // GlobalProvider's ticketDraft / sessionRecovery.ts).
    if (
      !location.state?.resumeBeneficialOwnershipTicket &&
      !wasTicketDraftRestored()
    ) {
      resetTicketDraft();
    }
  }, []);

  return (
    <section className='standard-workflow-page Home-HeaderDown'>
      <BeneficialOwnershipWorkflow />
    </section>
  );
};

export default BeneficialOwnershipPage;
